var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"content"}),(
      this.$route.name !== 'login' && //登录页
      this.$route.name !== 'appTojoin' && //申请加入页
      this.$route.name !== 'myEstimate' && //评估页
      this.$route.name !== 'undercarriage' && //课程已下架页
      this.$route.name !== 'payText' //图文详情-付费
    )?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }